import React from 'react'

import {
  AlignItems,
  BorderStyle,
  Box,
  Color,
  Display,
  DisplayPosition,
  FlexDirection,
  FontWeight,
  Icon,
  IconVariant,
  JustifyContent,
  Text,
} from '@gousto-internal/citrus-react'

export type EducationProps = {
  onClose: () => void
}

const Education = ({ onClose }: EducationProps) => (
  <Box width="100%">
    <Box
      position={DisplayPosition.Absolute}
      color={Color.ColdGrey_900}
      width="10px"
      top="-13px"
      right={['45px', '50px']}
      style={{
        transform: 'translateX(-85%)',
      }}
    >
      ▲
    </Box>
    <Box
      width="100%"
      bg={Color.ColdGrey_900}
      paddingV={3}
      paddingH={3}
      borderRadius={1.5}
      borderStyle={BorderStyle.Solid}
      color={Color.White}
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      alignItems={AlignItems.FlexStart}
    >
      <Box
        width="100%"
        display={Display.Flex}
        alignItems={AlignItems.Center}
        justifyContent={JustifyContent.SpaceBetween}
        paddingBottom={2}
      >
        <Text size={3} fontWeight={FontWeight.Bold}>
          Your recipe, your way
        </Text>
        <Icon
          name="close"
          variant={IconVariant.Inherit}
          onClick={(e) => {
            e.stopPropagation()
            onClose()
          }}
          style={{ cursor: 'pointer' }}
        >
          Close tooltip
        </Icon>
      </Box>
      <Text color={Color.White} size={1}>
        We pick the option we think you&apos;ll love and you can customise as you choose.
      </Text>
    </Box>
  </Box>
)

export { Education }
